import React, { useState } from "react";

interface StreamInterface {
    id: number;
    name: string;
    color: string;
}

const streams = [
    {
        id: 7,
        name: "X",
        color: "#000",
    },
    {
        id: 8,
        name: "Facebook",
        color: "#3b5998",
    },
    {
        id: 10,
        name: "Instagram",
        color: "#e1306c",
    },
    {
        id: 9,
        name: "YouTube",
        color: "#f61c0d",
    },
    {
        id: 11,
        name: "LinkedIn",
        color: "#2977c9",
    },
    {
        id: 12,
        name: "X",
        color: "#000",
    },
    {
        id: 13,
        name: "Facebook",
        color: "#3b5998",
    },
    {
        id: 14,
        name: "YouTube",
        color: "#f61c0d",
    },
    {
        id: 15,
        name: "Instagram",
        color: "#e1306c",
    },
    {
        id: 16,
        name: "LinkedIn",
        color: "#2977c9",
    },
    {
        id: 17,
        name: "TikTok",
        color: "#2977c9",
    },
] as StreamInterface[];

export const useStream = (key: any) => {
    if (typeof key === "string") {
        return streams.find((x) => x.name === key.toLowerCase()) || streams[0];
    } else if (typeof key === "number") {
        return streams.find((x) => x.id === key) || streams[0];
    } else {
        return streams[0];
    }
};
